/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Dubbing_Export_Background_Stem_LabelInputs */



/**
* | output |
* | --- |
* | "Background Stem" |
*
* @param {Audio_Dubbing_Export_Background_Stem_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_dubbing_export_background_stem_label = /** @type {((inputs?: Audio_Dubbing_Export_Background_Stem_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Dubbing_Export_Background_Stem_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Stem d'arrière-plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hintergrund-Stem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stem di sottofondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фоновый стем")
	if (locale === "es") return /** @type {LocalizedString} */ ("Stem de fondo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("背景音轨")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バックグラウンドステム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैकग्राउंड स्टेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Stem de fundo")
	return /** @type {LocalizedString} */ ("Background Stem")
});